import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {GetAnalyticsDashboard} from 'insights/analytics-dashboards/details/graphql/__generated/GetAnalyticsDashboard';
import {getAnalyticsQueryViewStateId} from 'insights/analytics-queries/AnalyticsQueryViewState';
import runWarehouseQueryGlobalState from 'insights/analytics-queries/run-query/runWarehouseQueryGlobalState';
import {AsyncStatus} from 'ui-library/hooks/useAsyncState';

import {getVisibleAnalyticsQueryIds, ScreenState} from '../details/view-state/ScreenState';

type AnalyticsDashboard = ExtractByTypename<
  GetAnalyticsDashboard['analyticsDashboard'],
  'AnalyticsDashboardNode'
>;

export default function useAreAnyAnalyticsQueriesRunning(
  {analyticsQueries}: AnalyticsDashboard,
  analyticsDashboardViewStateId: string
): boolean {
  const analyticsQueryViewStateIds = analyticsQueries.map((analyticsQuery) =>
    getAnalyticsQueryViewStateId(analyticsQuery.id, analyticsDashboardViewStateId)
  );
  const [runQueryStatesById] = runWarehouseQueryGlobalState.useGlobalClientStates(analyticsQueryViewStateIds);
  return analyticsQueryViewStateIds.some(
    (analyticsQueryViewStateId) =>
      runQueryStatesById[analyticsQueryViewStateId].status === AsyncStatus.LOADING
  );
}

export function useAreAnyVisibleAnalyticsQueriesRunning(
  analyticsDashboard: AnalyticsDashboard,
  analyticsDashboardViewStateId: string,
  screenState: ScreenState
): boolean {
  const visibleAnalyticsQueryViewStateIds = getVisibleAnalyticsQueryIds(analyticsDashboard, screenState).map(
    (analyticsQueryId) => getAnalyticsQueryViewStateId(analyticsQueryId, analyticsDashboardViewStateId)
  );
  const [runQueryStatesById] = runWarehouseQueryGlobalState.useGlobalClientStates(
    visibleAnalyticsQueryViewStateIds
  );

  return visibleAnalyticsQueryViewStateIds.some(
    (analyticsQueryViewStateId) =>
      runQueryStatesById[analyticsQueryViewStateId].status === AsyncStatus.LOADING
  );
}
